// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__36SOz","label":"SetPasswdForm_label__3QVMv"};